module.exports = __webpack_public_path__ + "static/11-b09336357b2430b4ff3196a3d017c5ae.jpeg";